//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

import Money from '@motionelements/money';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import SubscribeBtn from './SubscribeBtn.vue';
import SubscribePriceReseller from './SubscribePriceReseller.vue';
import SubscribePricesCards from './SubscribePricesCards.vue';

export default {
  name: 'SubscribePrice',
  mixins: [featureFlagMixin],
  components: {
    SubscribeBtn,
    SubscribePriceReseller,
    SubscribePricesCards,
  },
  data() {
    return {
      activePlanSku: '',
    };
  },
  watch: {
    getPlanBilledYearly() {
      if (this.getPlanBilledYearly) {
        this.activePlanSku = this.getPlanBilledYearly.sku;
      }
    },
  },
  computed: {
    ...mapGetters({
      isResellerCustomer: 'user/isResellerCustomer',
      isPlansLoaded: 'subscription/isPlansLoaded',
      getPlanBilledYearly: 'subscription/getPlanBilledYearly',
      getPlanBilledMonthly: 'subscription/getPlanBilledMonthly',
    }),
    isPlanBilledMonthly() {
      return this.getPlanBilledMonthly;
        // && !['ja', 'ko', 'zh-hant', 'th'].includes(this.$i18n.locale); // let API handle this
    },
    monthlyPrice() {
      return Money(this.getPlanBilledYearly.priceMonthly).toFormat('$0,0');
    },
    totalPrice() {
      return Money(this.getPlanBilledYearly.price).toFormat('$0,0');
    },
  },
};
